import { render } from "./McProject.vue?vue&type=template&id=281add88"
import script from "./McProject.vue?vue&type=script&lang=js"
export * from "./McProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__